import { useState } from "react";
import { connect } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { Show } from "../../../../hooks/Show";

const ToggleStatusPackagingButtonComponent = ({
  isActive = false,
  idPackaging = null,
  reduxDeletePackaging = () => {},
  reduxActivatePackaging = () => {},
}) => {
  const [showConfirm, setShowConfirm] = useState(false);

  const handleToggle = () => {
    if (isActive) {
      setShowConfirm(true);
    } else {
      reduxActivatePackaging({ id: idPackaging });
    }
  };

  const handleConfirmDeactivate = () => {
    setShowConfirm(false);
    reduxDeletePackaging({ id: idPackaging });
  };

  return (
    <Show when="feature:wms-packaging-delete">
      <button
        title={isActive ? "Desactivar" : "Activar"}
        className={`btn btn-sm btn-circle mr-2 ${
          isActive ? "btn-danger" : "btn-success"
        }`}
        type="button"
        onClick={handleToggle}
      >
        <i className={`fas fa-${isActive ? "ban" : "toggle-on"} fa-xs`}></i>
      </button>

      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Desactivar Embalaje</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-0">
            ¿Está seguro de que desea desactivar este embalaje? No podrá ser
            utilizado en procesos operativos ni editado.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirm(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleConfirmDeactivate}>
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>
    </Show>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    reduxDeletePackaging: (payload) =>
      dispatch({
        type: "DELETE_PACKAGING_REQUEST",
        value: payload,
      }),
    reduxActivatePackaging: (payload) =>
      dispatch({
        type: "ACTIVATE_PACKAGING_REQUEST",
        value: payload,
      }),
  };
};

export const DeletePackagingButton = connect(
  null,
  mapDispatchToProps,
)(ToggleStatusPackagingButtonComponent);
